import { createStructuredSelector } from "reselect";
import {
    COM_PURCHASE_ORDER,
    COM_PURCHASE_ORDER_SUCCESS,
    COM_PURCHASE_ORDER_ERROR,
    COM_SUPPLIER,
    COM_SUPPLIER_SUCCESS,
    COM_SUPPLIER_ERROR,
    COM_CATEGORY,
    COM_CATEGORY_SUCCESS,
    COM_CATEGORY_ERROR,
    COM_USER_ASSIGNED,
    COM_USER_ASSIGNED_SUCCESS,
    COM_USER_ASSIGNED_ERROR,
    COM_STATUS,
    COM_STATUS_SUCCESS,
    COM_STATUS_ERROR,
    COM_USER_FOR_ASSIGN,
    COM_USER_FOR_ASSIGN_SUCCESS,
    COM_USER_FOR_ASSIGN_ERROR,
    COMMUNICATION_LIST,
    COMMUNICATION_LIST_SUCCESS,
    COMMUNICATION_LIST_ERROR,
    COMMUNICATION_SEARCH_CHANGE,
    COMMUNICATION_PAGE_SET,
    COMMUNICATION_EDIT_MODAL_SET,
    COMMUNICATION_EDIT_SET_DATA,
    COMMUNICATION_EDIT_CHANGE_SET,
    COMMUNICATION_EDIT,
    COMMUNICATION_EDIT_SUCCESS,
    COMMUNICATION_EDIT_ERROR,
    COMMUNICATION_ANSWER_MODAL_SET,
    COMMUNICATION_ANSWER_SET_DATA,
    COMMUNICATION_ANSWER_CHANGE_SET,
    COMMUNICATION_ANSWER,
    COMMUNICATION_ANSWER_SUCCESS,
    COMMUNICATION_ANSWER_ERROR,
    COMMUNICATION_SEE_MODAL_SET,
    COMMUNICATION_SEE_SET_DATA,
    COMMUNICATION_UPLOAD_SET,
    COMMUNICATION_UPLOAD_SET_SUCCESS,
    COMMUNICATION_UPLOAD_SET_ERROR,
    COMMUNICATION_UPLOAD_RESET,
} from "../actions";

export const NAME = 'adminCommunication';

export const ComPurchaseOrder = (data) => ({
    type: COM_PURCHASE_ORDER,
    payload: data
});

export const ComPurchaseOrderSuccess = (data) => ({
    type: COM_PURCHASE_ORDER_SUCCESS,
    payload: data
});

export const ComPurchaseOrderError = (error) => ({
    type: COM_PURCHASE_ORDER_ERROR,
    payload: error
});

export const ComSupplier = (data) => ({
    type: COM_SUPPLIER,
    payload: data
});

export const ComSupplierSuccess = (data) => ({
    type: COM_SUPPLIER_SUCCESS,
    payload: data
});

export const ComSupplierError = (error) => ({
    type: COM_SUPPLIER_ERROR,
    payload: error
});

export const ComCategory = (data) => ({
    type: COM_CATEGORY,
    payload: data
});

export const ComCategorySuccess = (data) => ({
    type: COM_CATEGORY_SUCCESS,
    payload: data
});

export const ComCategoryError = (error) => ({
    type: COM_CATEGORY_ERROR,
    payload: error
});

export const ComUserAssigned = (data) => ({
    type: COM_USER_ASSIGNED,
    payload: data
});

export const ComUserAssignedSuccess = (data) => ({
    type: COM_USER_ASSIGNED_SUCCESS,
    payload: data
});

export const ComUserAssignedError = (error) => ({
    type: COM_USER_ASSIGNED_ERROR,
    payload: error
});

export const ComStatus = (data) => ({
    type: COM_STATUS,
    payload: data
});

export const ComStatusSuccess = (data) => ({
    type: COM_STATUS_SUCCESS,
    payload: data
});

export const ComStatusError = (error) => ({
    type: COM_STATUS_ERROR,
    payload: error
});

export const ComUserForAssign = (data) => ({
    type: COM_USER_FOR_ASSIGN,
    payload: data
});

export const ComUserForAssignSuccess = (data) => ({
    type: COM_USER_FOR_ASSIGN_SUCCESS,
    payload: data
});

export const ComUserForAssignError = (error) => ({
    type: COM_USER_FOR_ASSIGN_ERROR,
    payload: error
});

export const CommunicationList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: COMMUNICATION_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const CommunicationListSuccess = (data) => ({
    type: COMMUNICATION_LIST_SUCCESS,
    payload: data
});

export const CommunicationListError = (error) => ({
    type: COMMUNICATION_LIST_ERROR,
    payload: error
});

export const CommunicationPageSet = (data) => ({
    type: COMMUNICATION_PAGE_SET,
    payload: data
});

export const CommunicationSearchChange = (data) => ({
    type: COMMUNICATION_SEARCH_CHANGE,
    payload: data
});


export const CommunicationEditModalSet = (data) => ({
    type: COMMUNICATION_EDIT_MODAL_SET,
    payload: data
});

export const CommunicationEditSetData = (data) => ({
    type: COMMUNICATION_EDIT_SET_DATA,
    payload: data
});


export const CommunicationEditChangeSet = (data) => ({
    type: COMMUNICATION_EDIT_CHANGE_SET,
    payload: data
});

export const CommunicationEdit = (page, num_page, orderBy, filters, data) => ({
    type: COMMUNICATION_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const CommunicationEditSuccess = (message) => ({
    type: COMMUNICATION_EDIT_SUCCESS,
    payload: message
});

export const CommunicationEditError = (error) => ({
    type: COMMUNICATION_EDIT_ERROR,
    payload: error
});

export const CommunicationAnswerModalSet = (data) => ({
    type: COMMUNICATION_ANSWER_MODAL_SET,
    payload: data
});

export const CommunicationAnswerSetData = (data) => ({
    type: COMMUNICATION_ANSWER_SET_DATA,
    payload: data
});


export const CommunicationAnswerChangeSet = (data) => ({
    type: COMMUNICATION_ANSWER_CHANGE_SET,
    payload: data
});

export const CommunicationAnswer = (page, num_page, orderBy, filters, data) => ({
    type: COMMUNICATION_ANSWER,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const CommunicationAnswerSuccess = (message) => ({
    type: COMMUNICATION_ANSWER_SUCCESS,
    payload: message
});

export const CommunicationAnswerError = (error) => ({
    type: COMMUNICATION_ANSWER_ERROR,
    payload: error
});

export const CommunicationSeeModalSet = (data) => ({
    type: COMMUNICATION_SEE_MODAL_SET,
    payload: data
});

export const CommunicationSeeSetData = (data) => ({
    type: COMMUNICATION_SEE_SET_DATA,
    payload: data
});

export const CommunicationUploadSet = (file) => ({
    type: COMMUNICATION_UPLOAD_SET,
    payload: { file },
});

export const CommunicationUploadSetSuccess = (items) => ({
    type: COMMUNICATION_UPLOAD_SET_SUCCESS,
    payload: items,
});

export const CommunicationUploadSetError = (error) => ({
    type: COMMUNICATION_UPLOAD_SET_ERROR,
    payload: error,
});

export const CommunicationUploadReset = () => ({
    type: COMMUNICATION_UPLOAD_RESET
});

const adminCommunication = (state) => state[NAME];

export const AdminCommunicationSelector = createStructuredSelector({
    adminCommunication
})